import Flickity from 'flickity';
window.Flickity = Flickity
import "flickity-fade";
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    let targets = document.querySelectorAll('.b-main-quotes-item')
    if (targets.length > 1 ) {
      let flkty = new Flickity('.b-main-quotes__list',{
        draggable: isMobile,
        freeScroll: isMobile,
        prevNextButtons: true,
        pageDots: false,
        // contain: true,
        wrapAround: true,
        fade: !isMobile,
        cellAlign: 'left',
        adaptiveHeight: true
        // arrowShape: 'M11.465.563a1.5 1.5 0 00-2.121.01l-8.41 8.5a1.5 1.5 0 000 2.11l8.41 8.5a1.5 1.5 0 002.133-2.11L5.593 11.63H50a1.5 1.5 0 000-3H5.594l5.882-5.945a1.5 1.5 0 00-.01-2.121z'
        // arrowShape: {
        //   x0: 15,
        //   x1: 60, y1: 50,
        //   x2: 65, y2: 50,
        //   x3: 20
        // }
      });
    }
    
  }, 100);
})


